// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/puff-the-magic-dragon.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const puffTheMagicDragon: Score = {
  slug: "puff-the-magic-dragon",
  n: 13,
  title: "Puff the Magic Dragon",
  composer: "Leonard Lipton & Peter Yarrow",
  rights: "in-copyright",
  publicSafe: false,
  key: "D",
  fifths: 2,
  time: [4, 4],
  tempo: 88,
  staves: 2,
  clefs: ["treble", "bass"],
  bars: 17,
  barQuarters: 4.0,
  lowest: 50,
  highest: 76,
  hasLyrics: false,
  jasonNote: "\"Puff, the Magic Dragon\" is a song written by Leonard Lipton and Peter Yarrow, and made popular by Yarrow's group - Peter, Paul and Mary in a 1963 recording",
  teaches: [
    "whole-note left-hand pedal tones",
    "D major and its two sharps",
    "dotted rhythms in the melody",
    "an eighth rest on the second beat"
  ],
  art: "/sight-reading/art/puff-the-magic-dragon.jpg",
  artRights: "studio",
  background: "/sight-reading/bg/puff-the-magic-dragon.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 1, hand: "lh", start: 0.0, dur: 4.0, midi: 50, pitch: "D3", d: "whole" },
    { bar: 1, hand: "rh", start: 1.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 1, hand: "rh", start: 1.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 2, hand: "rh", start: 4.0, dur: 2.0, midi: 73, pitch: "C#5", d: "half" },
    { bar: 2, hand: "lh", start: 4.0, dur: 4.0, midi: 54, pitch: "F#3", d: "whole" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, midi: 69, pitch: "A4", d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.5, midi: 71, pitch: "B4", d: "quarter", dot: true },
    { bar: 3, hand: "lh", start: 8.0, dur: 4.0, midi: 55, pitch: "G3", d: "whole" },
    { bar: 3, hand: "rh", start: 9.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth", tie: "start" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter", tie: "stop" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 4, hand: "rh", start: 12.0, dur: 3.0, midi: 69, pitch: "A4", d: "half", dot: true },
    { bar: 4, hand: "lh", start: 12.0, dur: 4.0, midi: 50, pitch: "D3", d: "whole" },
    { bar: 4, hand: "rh", start: 15.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 5, hand: "lh", start: 16.0, dur: 4.0, midi: 55, pitch: "G3", d: "whole" },
    { bar: 5, hand: "rh", start: 17.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 5, hand: "rh", start: 18.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 6, hand: "rh", start: 20.0, dur: 1.0, midi: 66, pitch: "F#4", d: "quarter" },
    { bar: 6, hand: "lh", start: 20.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 6, hand: "rh", start: 21.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 6, hand: "rh", start: 22.0, dur: 1.5, midi: 74, pitch: "D5", d: "quarter", dot: true },
    { bar: 6, hand: "lh", start: 22.0, dur: 2.0, midi: 59, pitch: "B3", d: "half" },
    { bar: 6, hand: "rh", start: 23.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 7, hand: "rh", start: 24.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 7, hand: "lh", start: 24.0, dur: 4.0, midi: 52, pitch: "E3", d: "whole" },
    { bar: 7, hand: "rh", start: 25.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 73, pitch: "C#5", d: "quarter" },
    { bar: 7, hand: "rh", start: 27.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 76, pitch: "E5", d: "whole" },
    { bar: 8, hand: "lh", start: 28.0, dur: 4.0, midi: 57, pitch: "A3", d: "whole" },
    { bar: 9, hand: "rh", start: 32.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 9, hand: "lh", start: 32.0, dur: 4.0, midi: 50, pitch: "D3", d: "whole" },
    { bar: 9, hand: "rh", start: 33.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 9, hand: "rh", start: 33.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 9, hand: "rh", start: 34.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 9, hand: "rh", start: 35.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 10, hand: "rh", start: 36.0, dur: 2.0, midi: 73, pitch: "C#5", d: "half" },
    { bar: 10, hand: "lh", start: 36.0, dur: 4.0, midi: 54, pitch: "F#3", d: "whole" },
    { bar: 10, hand: "rh", start: 38.0, dur: 2.0, midi: 69, pitch: "A4", d: "half" },
    { bar: 11, hand: "rh", start: 40.0, dur: 1.5, midi: 71, pitch: "B4", d: "quarter", dot: true },
    { bar: 11, hand: "lh", start: 40.0, dur: 4.0, midi: 55, pitch: "G3", d: "whole" },
    { bar: 11, hand: "rh", start: 41.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth", tie: "start" },
    { bar: 11, hand: "rh", start: 42.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter", tie: "stop" },
    { bar: 11, hand: "rh", start: 43.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 12, hand: "rh", start: 44.0, dur: 3.0, midi: 69, pitch: "A4", d: "half", dot: true },
    { bar: 12, hand: "lh", start: 44.0, dur: 4.0, midi: 50, pitch: "D3", d: "whole" },
    { bar: 12, hand: "rh", start: 47.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 13, hand: "rh", start: 48.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 13, hand: "lh", start: 48.0, dur: 4.0, midi: 55, pitch: "G3", d: "whole" },
    { bar: 13, hand: "rh", start: 49.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 13, hand: "rh", start: 50.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 13, hand: "rh", start: 51.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 14, hand: "rh", start: 52.0, dur: 1.0, midi: 66, pitch: "F#4", d: "quarter" },
    { bar: 14, hand: "lh", start: 52.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 14, hand: "rh", start: 53.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 14, hand: "rh", start: 54.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 14, hand: "lh", start: 54.0, dur: 2.0, midi: 59, pitch: "B3", d: "half" },
    { bar: 14, hand: "rh", start: 55.0, dur: 0.5, rest: true, d: "eighth" },
    { bar: 14, hand: "rh", start: 55.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 15, hand: "rh", start: 56.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 15, hand: "lh", start: 56.0, dur: 2.0, midi: 52, pitch: "E3", d: "half" },
    { bar: 15, hand: "rh", start: 57.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 15, hand: "rh", start: 58.0, dur: 1.0, midi: 73, pitch: "C#5", d: "quarter" },
    { bar: 15, hand: "lh", start: 58.0, dur: 2.0, midi: 57, pitch: "A3", d: "half" },
    { bar: 15, hand: "rh", start: 59.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 16, hand: "rh", start: 60.0, dur: 4.0, midi: 74, pitch: "D5", d: "whole" },
    { bar: 16, hand: "lh", start: 60.0, dur: 4.0, midi: 50, pitch: "D3", d: "whole" },
    { bar: 17, hand: "rh", start: 64.0, dur: 4.0, rest: true, d: "whole" },
    { bar: 17, hand: "lh", start: 64.0, dur: 4.0, rest: true, d: "whole" },
  ],
};
